export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختر المتجر"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["بدون عنوان"])}
}